<form [formGroup]="dateRangeForm">
   <div class="flex flex-column gap-2 mr-2">
      <p-calendar
         formControlName="range"
         selectionMode="range"
         [readonlyInput]="true"
         [showIcon]="true"
         [showTime]="false"
         [iconDisplay]="'input'"
         [inputId]="filter.filter.id"
         [dateFormat]="'dd/mm/yy'"
         [showButtonBar]="true"
         styleClass="w-full min-width md:w-80"
         class="w-full min-width md:w-80"
         [placeholder]="'Entra ' + filter.filter.label"

      />

      <div *ngIf="dateRangeForm.get('range')?.invalid && dateRangeForm.get('range')?.touched" class="text-red-700">
         {{ 'DATA.COMMON.FORM.ERROR.DATE_RANGE_INVALID' | translate }}
      </div>
   </div>
</form>
